<template>
  <div class="error-container">
    <emat-button bg-color="red" @click="tryAgain">{{ $t('OrderPopupBodyDanger.try_again') }}</emat-button>
  </div>
</template>

<script>
import EmatButton from "Components/General/Button/index";

export default {
  name: "OrderPopupBodyDanger",
  components: {
    EmatButton
  },

  props: {
    tryAgain: {
      required: true,
      type: Function
    }
  }
}
</script>

<style scoped>
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
